import { facilityNoteCategorySchema } from "@clipboard-health/contract-backend-main";
import { useGetQuery, type UseGetQueryOptions } from "@src/appV2/api";
import { environmentConfig } from "@src/appV2/environment";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import { z } from "zod";

const useGetFacilityNotesResponseSchema = z.array(facilityNoteCategorySchema);

type UseGetFacilityNotesResponse = z.infer<typeof useGetFacilityNotesResponseSchema>;

export function useGetFacilityNotes(
  facilityId: string,
  options: UseGetQueryOptions<UseGetFacilityNotesResponse> = {}
) {
  return useGetQuery({
    url: `${environmentConfig.REACT_APP_API_MAIN_URL}/api/facilityNoteCategory/get-notes/${facilityId}`,
    responseSchema: useGetFacilityNotesResponseSchema,
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.GET_FACILITY_NOTES_FAILURE,
      userErrorMessage:
        "Error while fetching notes. Please try again or contact Support if the issue persists.",
    },
    ...options,
  });
}
